import CisionPressReleaseListPage from './CisionPressReleaseListPage';

export default CisionPressReleaseListPage;
